import { MessageBox, Loading } from 'element-ui'
import { getToken, getUserToken } from '@/utils/cookies'
import constant from '@/api/constant'

const utils = {
}
/** 消息提示方法 */
utils.msgAlert = function (type, msg) {
  MessageBox.alert(msg, '提示', {
    confirmButtonText: '确定',
    type: type,
    callback: action => {
    }
  })
}
/** 遮罩 */
utils.Loading = function (tipsMsg) {
  const loading = Loading.service({
    lock: true,
    text: tipsMsg,
    background: 'rgba(0, 0, 0, 0.7)'
  })
  return loading
}

/** 不为空的判断 */
utils.isNotEmpty = function (param) {
  var falg = false
  if (param !== '' && param !== undefined && param !== null) {
    falg = true
  }
  return falg
}

/** 拼接axios请求参数配置 */
utils.getAxiosOption = function (method, url, params, data) {
  var option = {
    method: method,
    url: url,
    params: params,
    data: data
  }
  return option
}

/** 手机号替换中间四位**** */
utils.phoneReplace = function (val) {
  if (val !== '' && val !== undefined && val !== null) {
    let reg = /^(.{3}).*(.{4})$/
    return val.replace(reg, '$1****$2')
  }
}

/** 生成UUID */
utils.uuid = function () {
  var s = []
  var hexDigits = getUserToken() + getToken()
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  var uuid = s.join('')
  return uuid
}

/** 获取数组中的目标数据，数组格式 [{id: 1},{id: 2}] */
utils.getOptionItemInArray = function (arrayData, validField, validContent) {
  let targetObj = {}
  targetObj = arrayData.find((item) => {
    return item[validField] === validContent
  })
  return targetObj
}

/** 获取数组中目标数据索引 */
utils.getOptionIndexInArray = function (arrayData, validField, validContent) {
  let changeIndex = -1
  changeIndex = arrayData.findIndex((item, index) => {
    return item[validField] === validContent
  })
  return changeIndex
}

/** 移除数组中的目标数据 */
utils.reduceOptionItemInArray = function (arrayData, validField, validContent) {
  if (arrayData.length > 0) {
    for (let i = 0; i < arrayData.length; i++) {
      if (arrayData[i][validField] === validContent) {
        arrayData.splice(i, 1)
      }
    }
  }
}
/** 移除数组中元素 */
utils.reduceItemInArray = function (arrayData, validContent) {
  if (arrayData.length > 0) {
    for (let itemIndex in arrayData) {
      if (arrayData[itemIndex] === validContent) {
        arrayData.splice(itemIndex, 1)
      }
    }
  }
}
/**** 防抖  ****/
utils.debounce = function(fn, delay=100){
    if(this.timer) clearTimeout(this.timer) 
    this.timer = setTimeout(fn, delay);
},
utils.getToReadUrlByCategory = (category, params, type) => {
  console.log('category',category)
  let readType = {
    onLineLS:'/service',
    onLineBS:'/readerPDF'
  }
  let readTypeH5 = {
    onLineLS:'/read_al',
    onLineBS:'/mreaderPDF'
  }
  let toReadPath = constant.read_web_url
  if ((constant.pl_kec == category) || (constant.pl_sp == category) || (constant.pl_yp == category)) {  
    console.log("test999", toReadPath)
    toReadPath += '/read_cl?resourceId=' + params.resourceId + '&type=' + category
  } else if ((constant.pl_sj == category)) {
    // toReadPath += '/pcExam?resourceId=' + params.resourceId + '&type=' + category
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      toReadPath += '/mobiExamStart?resourceId=' + params.resourceId + '&type=' + category
      }else{
      toReadPath += '/pcExam?resourceId=' + params.resourceId + '&type=' + category
    }
    delete params["title"]
    params['masterId'] = 0, params['doPaperDate'] = 'doAgain', params['submitId'] = ''
  } else if ((constant.pl_al == category)||(constant.pl_xxzl == category) || (constant.pl_ts == category) ||  (constant.pl_gf== category) ||  (constant.pl_wz== category) ||  (constant.pl_lxcbw== category)||(constant.pl_bz==category)||(constant.pl_ptzy==category)||(constant.pl_tp==category)) {
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      toReadPath += readTypeH5[type] + '?resourceId=' + params.resourceId + '&type=' + category
    } else {
      toReadPath += readType[type] + '?resourceId=' + params.resourceId + '&type=' + category
    }
  }else if ((constant.pl_zlj == category) ) {
    // toReadPath += '/pcCatalog?resourceId=' + params.resourceId + '&type=' + category
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      toReadPath += '/mCatalog?resourceId=' + params.resourceId + '&type=' + category
      }else{
      toReadPath += '/pcCatalog?resourceId=' + params.resourceId + '&type=' + category
    }
  } else if ((constant.pl_xt == category)) {
    // toReadPath += '/pcExercises?resourceId=' + params.resourceId + '&type=' + category
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      toReadPath += '/mobiExercises?resourceId=' + params.resourceId + '&type=' + category
      }else{
      toReadPath += '/pcExercises?resourceId=' + params.resourceId + '&type=' + category
    }
    delete params["title"]
    params['masterId'] = 0, params['doPaperDate'] = 'doAgain', params['submitId'] = ''
  } else {
    toReadPath = ''
  }
  delete params["resourceId"]
  if (utils.isNotEmpty(toReadPath)) {
    for (let paramIndex in params) {
      toReadPath += '&' + paramIndex + '=' + params[paramIndex]
    }
  }
  return toReadPath
}



export default utils



// WEBPACK FOOTER //
// ./src/utils/utils.js